import { render, staticRenderFns } from "./TheSwiper.vue?vue&type=template&id=347359ea"
import script from "./TheSwiper.vue?vue&type=script&lang=ts"
export * from "./TheSwiper.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports